<template>
    <form-accordion
        name="tenant-roster"
        section="Tenant Roster"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <square-feet
            :read_only="read_only"
        />

        <tenant-roster
            :property="property"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import SquareFeet from './square-feet.vue';
import TenantRoster from './tenant-roster.vue';

export default {
    components: {
        SquareFeet,
        TenantRoster,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
